import Controller from "./call.controller";
import template from "./call.html";

const call = {
  template,
  controller: Controller,
  bindings: {
    startWatchEvent: "<",
    clearWatchEvent: "<",
    endCallEvent: "<",
    status: "=",
  },
};

export default call;



// WEBPACK FOOTER //
// ./src/components/call/call.component.js